var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.Quote.text))]),_c('p',{staticStyle:{"font-family":"Avenir, Helvetica, Arial, sans-serif"}},[_c('strong',[_vm._v("-- "+_vm._s(_vm.Quote.author))])])])}
var staticRenderFns = []

export { render, staticRenderFns }